
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#about', label: 'О нас' },
    { href: '#services', label: 'Услуги' },
    { href: '#cases', label: 'Преимущества' },
    { href: '#contact', label: 'Контакты' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-dark/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-transparent py-4 sm:py-6'
      } ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between">
        {/* Logo */}
        <a 
          href="#" 
          className={`flex items-center gap-2 sm:gap-3 cursor-pointer transition-all duration-500 ${
            isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
          }`}
          style={{ transitionDelay: '200ms' }}
        >
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gold rounded-md flex items-center justify-center">
            <span className="font-heading text-xl sm:text-2xl font-bold text-dark tracking-wider">AG</span>
          </div>
          <div className="flex flex-col">
            <h1>
              <span className="font-heading text-base sm:text-lg font-bold text-white tracking-wide">GA HR Group</span>
            </h1>
            <span className="font-body text-[10px] sm:text-xs text-white/60 -mt-0.5">HR-бизнес-партнёр</span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <div 
          className={`hidden lg:flex items-center gap-8 transition-all duration-500 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
          }`}
          style={{ transitionDelay: '400ms' }}
        >
          {navLinks.map((link, index) => (
            <a
              key={link.href}
              href={link.href}
              className="font-body text-sm text-white/70 hover:text-gold transition-colors duration-300 cursor-pointer"
              style={{ 
                transitionDelay: isLoaded ? `${(index + 3) * 100}ms` : '0ms',
                opacity: isLoaded ? 1 : 0,
                transform: isLoaded ? 'translateY(0)' : 'translateY(-8px)'
              }}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <a
          href="#contact"
          className={`hidden lg:block px-5 py-2.5 bg-gold text-dark font-body font-semibold text-sm rounded-md hover:bg-gold-dark transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105 ${
            isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
          }`}
          style={{ transitionDelay: '600ms' }}
        >
          Консультация
        </a>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer transition-all duration-500 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          aria-label="Меню"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl transition-transform duration-300`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 w-full bg-dark/98 backdrop-blur-md border-t border-white/10 transition-all duration-300 ${
          isMobileMenuOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-4'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col gap-4">
          {navLinks.map((link, index) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="font-body text-base text-white/70 hover:text-gold transition-all duration-300 py-2 cursor-pointer"
              style={{
                transitionDelay: isMobileMenuOpen ? `${index * 50}ms` : '0ms',
                opacity: isMobileMenuOpen ? 1 : 0,
                transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(-16px)'
              }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setIsMobileMenuOpen(false)}
            className="mt-2 px-5 py-3 bg-gold text-dark font-body font-semibold text-sm rounded-md text-center hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            Консультация
          </a>
        </div>
      </div>
    </nav>
  );
}
